module.exports = __webpack_public_path__ + "img/yunshipin.01f12853.png";